{
  "OptionsMenuTitle": "Zeigen Sie die verfügbaren Optionen für diesen Dashboard-Unterbericht an.",
  "DashboardDraggableTitle": "Ziehen Sie dies auf einen anderen Bericht in diesem Dashboard, um die Plätze zu tauschen.",
  "OptionsMenuRemove": "Bericht entfernen",
  "OptionsMenuAdd": "Neuen Bericht erstellen",
  "OptionsMenuModify": "Bericht ändern",
  "OptionsMenuChange": "Bericht wechseln",
  "OptionsMenuChoose": "Wählen Sie Bericht",
  "OptionMenuUpdateReportError": "Beim Versuch, den Dashboard-Bericht zu aktualisieren, ist ein Fehler aufgetreten.",
  "OptionMenuRemovePermDelete": "Diesen Bericht dauerhaft löschen",
  "NAME": "DashboardOptions"
}